import { css } from '@emotion/react'
import {
  DesignToken,
  Modal,
  ModalPortal,
  SpacingToken,
} from '@livechat/design-system-react-components'

import type { IApplication } from '@/apis/apps/interfaces'
import CannotBuyAlert from '@/components/Checkout/Alerts/CannotBuy'
import { useOneClickPaymentContext } from '@/context/OneClickPayment'
import useParamSelector from '@/hooks/useParamSelector'
import { getItemById } from '@/store/selectors'
import { usePreventScroll } from '@/utils/browser'
import PurchaseItem from '../PurchaseModal/Content/PurchaseItem'
import RequestBuyModalFooter from './Footer'
import RequestBuyModalHeader from './Header'

export const modalCss = css`
  width: 95vw;
  max-width: 600px;

  > div {
    padding: var(${SpacingToken.Spacing5}) var(${SpacingToken.Spacing7});
  }

  > div:first-of-type {
    border-bottom: 1px solid var(${DesignToken.BorderBasicTertiary});
  }

  > div:last-of-type {
    border-top: 1px solid var(${DesignToken.BorderBasicTertiary});
    margin-top: var(${SpacingToken.Spacing3});
  }

  p {
    margin: 0;
  }
`

export const RequestBuyModal = () => {
  usePreventScroll()

  const { closeModal, paymentIntent } = useOneClickPaymentContext()

  const itemId = paymentIntent?.metadata?.itemId || ''
  const item = useParamSelector(getItemById, itemId)

  if (!item) {
    return null
  }

  return (
    <ModalPortal zIndex={1000}>
      <Modal
        data-test="ocp-request-modal"
        css={modalCss}
        fullSpaceContent
        onClose={closeModal}
        heading={<RequestBuyModalHeader />}
        footer={<RequestBuyModalFooter onClose={closeModal} id={itemId} />}
      >
        <CannotBuyAlert />
        <PurchaseItem item={item as IApplication} />
      </Modal>
    </ModalPortal>
  )
}

export default RequestBuyModal
